import { Ulid } from "@kase/my-marathon-communication";
import { signal } from "@preact/signals";
import { upsert } from "~/utils";
import { ApiSliceParams } from "../interfaces";
import { AttachmentDuplicateState, Duplicate } from "./interfaces";

export const makeDuplicate = ({ connection, company }: ApiSliceParams) => {
    const duplicates = signal<Duplicate[]>([]);
    const loadedIds = new Set<string>();

    const check = async (ids: string[]) => {
        const con = connection.value;
        const finalIds = ids.filter((id) => !loadedIds.has(id));

        if (finalIds.length === 0) {
            return;
        }

        try {
            const res = await con.expense.receipt.checkDuplicate({
                ids: finalIds.map((id) => Ulid.fromString(id)),
                company: company.value,
            });
            const items: Duplicate[] = [];

            for (const item of res.duplicates) {
                // @TODO: type AttachmentDuplicateState is not exported from com lib
                const state = item.state as unknown as AttachmentDuplicateState;

                if (!item.id || state === AttachmentDuplicateState.Unique) {
                    continue;
                }

                const _id = Ulid.fromLoHi(item.id);

                items.push({
                    id: _id.toString(),
                    _id,
                    state,
                });
            }

            duplicates.value = upsert(duplicates.peek().slice(), items, "id");
            ids.forEach((id) => loadedIds.add(id));
        } catch (error: unknown) {
            console.error("Error checking duplicates:", error);
        }
    };

    const get = (id: string | Readonly<Ulid> | null | undefined) => {
        if (!id) {
            return null;
        }

        // @TODO: research if value or peek should be used (match with list-controller)
        return duplicates.value.find((i) => i.id === id) ?? null;
    };

    const getMany = (ids: string[]) =>
        duplicates.value.filter((i) => ids.includes(i.id));

    return {
        duplicates,
        check,
        get,
        getMany,
    };
};
